import projects from '@/data/projects'

const state = {
    projectSelected: false,
    isMenuOpen: false,
    projectsList: projects
}

const getters = {
    isMenuOpen: state => state.isMenuOpen,
    projectsList: state => state.projectsList,
    projectSelected: state => state.projectSelected
}

const actions = {
    setProjectSelected({ commit }, project) {
        commit('SET_PROJECT_SELECTED', project)
    },
    toggleMenuOverlay({ commit }, isMenuOpen) {
        commit('TOGGLE_MENU_OVERLAY', isMenuOpen)
    }
}

const mutations = {
    ['SET_PROJECT_SELECTED'](state, project) {
        state.projectSelected = project
    },
    ['TOGGLE_MENU_OVERLAY'](state, isMenuOpen) {
        state.isMenuOpen = isMenuOpen
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}